import { render, staticRenderFns } from "./SocleNotificationApprovalWorkflowPage.vue?vue&type=template&id=7b354e94&"
import script from "./SocleNotificationApprovalWorkflowPage.vue?vue&type=script&lang=ts&"
export * from "./SocleNotificationApprovalWorkflowPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports